import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrending5: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="trending-5, chart, analytics"><path d="M19.2188 10.9688L17.1562 8.90625L12 14.0625L9.42188 11.4844L4.13887 16.7674M3.75 3.75V20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTrending5;
